import React from 'react'
import Calendar from '../../components/calendar'

const EventsIndex = (props) => (
  <Calendar {...props} index />
)

export default EventsIndex
